import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Box, Button, Typography, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function AuditDetailScreen() {
  const { id } = useParams();

  return (
    <ScreenFrame
      title={`Audit ${id}`}
      actions={
        <>
          <Button component={Link} to="/prototype/audits" variant="outlined" size="small">Back to list</Button>
          <Button component={Link} to={`/prototype/audits/${id}/edit`} variant="contained" size="small">Edit</Button>
        </>
      }
    >
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">Retailer</Typography><Typography>Customer North</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Date</Typography><Typography>2024-03-01</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Status</Typography><Typography>Passed</Typography>
      </Paper>
      <Box sx={{ mt: 2 }}>
        <Button component={Link} to="/prototype/trace-test-auto" variant="outlined" size="small">Trace test</Button>
      </Box>
    </ScreenFrame>
  );
}
